import styled, { css, createGlobalStyle } from 'styled-components';

export const BodyFixed = createGlobalStyle`
    html, body {
        overflow: hidden;
        position: relative;
    }
`;

export const Overlay = styled.div`
    ${({ theme }) => css`
        background: ${theme.colors.accents[5].hex};
        opacity: 0.5;
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1000;
    `}
`;

export const Container = styled.div<{ $animate: boolean }>`
    ${({ theme, $animate }) => css`
        position: fixed;
        display: ${$animate ? 'block' : 'none'};
        opacity: 0;
        bottom: -100%;
        max-width: calc(100% - 1rem);
        left: 50%;
        transform: translateX(-50%);
        z-index: 2147483001;
        animation: ${$animate && 'slide 0.25s ease forwards'};

        @media ${theme.breakpoints.medium.media} {
            width: calc(86.5rem);
        }

        @keyframes slide {
            from {
                opacity: 0;
                bottom: -100%;
            }
            to {
                opacity: 1;
                bottom: 0;
            }
        }
    `}
`;

export const TableWrapper = styled.div<{ $isOpen: boolean }>`
    height: calc(100%);
    width: 0;

    ${({ $isOpen }) =>
        $isOpen &&
        css`
            width: auto;
        `}
`;
